import { browser } from '$app/environment';
import {
  PUBLIC_SUPABASE_ANON_KEY,
  PUBLIC_SUPABASE_URL
} from '$env/static/public';
import * as Sentry from '@sentry/sveltekit';
import { createSupabaseLoadClient } from '@supabase/auth-helpers-sveltekit';
import { writable } from 'svelte/store';

export const load = async ({ fetch, data, depends }) => {
  depends('supabase:auth');

  const supabase = createSupabaseLoadClient({
    supabaseUrl: PUBLIC_SUPABASE_URL,
    supabaseKey: PUBLIC_SUPABASE_ANON_KEY,
    event: { fetch },
    serverSession: data.session
  });

  const {
    data: { session }
  } = await supabase.auth.getSession();

  if (browser) {
    if (session?.user.id) {
      // track against sentry
      Sentry.setUser({
        id: session.user.id,
        email: session.user.email
      });
    } else {
      Sentry.setUser({
        id: data.guestId
      });
    }
  }

  const hasCompanion = writable(true);

  return {
    supabase,
    session,
    guestId: data.guestId,
    hasCompanion
  };
};
